import { SagaIterator } from 'redux-saga';
import { all, takeLatest } from 'redux-saga/effects';
import { SEND_ACCESS_CODE } from '../actions';
import sendAccessCodeWorker from './send-access-code-worker';

export default function* landingPageWatcher(): SagaIterator {
  yield all([takeLatest(SEND_ACCESS_CODE, sendAccessCodeWorker)]);
}
